import React, { Fragment, useEffect, useState, useRef } from 'react';
import { string, object, oneOfType, bool } from 'prop-types';
import { lowQualityImageSrc } from '../../../../themes/constants';
import * as S from './styled';

const LazyLoadImage = ({
  as,
  src,
  srcLowQuality,
  alt,
  withBlur,
  srcSet,
  sizes
}) => {
  const [imageSrc, setImageSrc] = useState(srcLowQuality);
  const [imageIsLoaded, setImageIsLoaded] = useState(false);
  const imageRef = useRef();

  const fetchImage = url => new Promise((resolve, reject) => {
    const image = new Image();
    image.onload = resolve;
    image.onerror = reject;
    image.src = url;
  });

  useEffect(() => {
    const currentRef = imageRef.current;

    const fetchImageAndSetState = async srcImage => {
      await fetchImage(srcImage);
      setImageSrc(src);
      setImageIsLoaded(true);
    };

    if ('IntersectionObserver' in window === false) {
      return fetchImageAndSetState(src);
    }

    const options = {
      rootMargin: '400px',
      threshold: 0.1
    };

    const handleIntersection = (entries, observer) => {
      entries.forEach(entry => {
        if (entry.intersectionRatio > 0) {
          fetchImageAndSetState(src);
          observer.unobserve(entry.target);
        }
      });
    };

    const observer = new IntersectionObserver(handleIntersection, options);

    if (!imageIsLoaded) {
      observer.observe(currentRef);
    }

    return () => observer.unobserve(currentRef);
  }, [imageIsLoaded, imageRef, src]);
  return /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement("noscript", null, /*#__PURE__*/React.createElement("img", {
    className: "crawler-image",
    src: src,
    alt: alt
  })), /*#__PURE__*/React.createElement(S.WrapperNoBlurOverflow, null, /*#__PURE__*/React.createElement(S.Wrapper, {
    withBlur: withBlur,
    imageIsLoaded: imageIsLoaded
  }, /*#__PURE__*/React.createElement(S.StyledImage, {
    srcSet: imageIsLoaded && srcSet ? srcSet : null,
    as: as,
    sizes: sizes,
    className: "lazy-image",
    ref: imageRef,
    src: imageSrc,
    alt: alt
  }))));
};

LazyLoadImage.propTypes = {
  src: string.isRequired,
  srcLowQuality: string,
  alt: string.isRequired,
  as: oneOfType([string, object]),
  withBlur: bool,
  sizes: string,
  srcSet: oneOfType([bool, string])
};
LazyLoadImage.defaultProps = {
  as: 'img',
  srcLowQuality: lowQualityImageSrc,
  withBlur: true,
  sizes: null,
  srcSet: false
};
export default LazyLoadImage;